import { createContext } from 'react';

interface UserScopeContextType {
  globalUserId: string | null;
  setGlobalUserId: (id: string | null) => void;
  overrideUserId: string | null;
  setOverrideUserId: (id: string | null) => void;
  effectiveUserId: string | null; // null => all users
  clearOverrides: () => void;
}

export const UserScopeContext = createContext<UserScopeContextType | undefined>(undefined);
